import { createFileRoute } from "@tanstack/react-router";
import { OtherConsentFormPage } from "@/features/consents";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";

export const Route = createFileRoute("/_consented/consent-forms_/$key")({
  staticData: { fullBleed: true },
  component: Page,
});

function Page() {
  const { profile } = Route.useRouteContext();
  return (
    <OtherConsentFormPage
      key={Route.useParams().key}
      patientId={patientDomainIdFromProfile(profile)}
      formKey={Route.useParams().key}
    />
  );
}
